import React from 'react';

const GiveSupportSection = () => {
    return (
        <p>
            Whether you’re looking to mentor others or be mentored yourself, WNB.rb is ready for
            you! Post in our #advice channel to get the perspective of someone who’s been in your
            shoes, or jump into the #ruby-questions channel to help someone struggling with a
            technical problem.
        </p>
    );
};
export default GiveSupportSection;
